import { Typography } from '@mui/joy'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AddWorkRule } from '~/features/common/WorkRule/AddWorkRule'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'working conditions', link: '/work-rules' },
  { titleI18n: 'new terms of work' },
]

function AddWorkRulePage() {
  const { t } = useTranslation()

  const [title, setTitle] = useState<string>()

  const handleTitleChange = useCallback((title: string) => setTitle(title), [])

  return (
    <PageContainer title={t('new terms of work')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('new terms of work')}</PageTitle>
        <Typography sx={{ minHeight: '24px' }}>{title}</Typography>
      </Container>
      <AddWorkRule onTitleChange={handleTitleChange} />
    </PageContainer>
  )
}

export default AddWorkRulePage
